import capitalize from 'lodash/capitalize'
import type {Category} from 'src/api/saleor/generated'
import type {Breadcrumb} from 'src/components/products/Breadcrumbs'

import {paths, generatePath} from '../paths'

export const categoryCrumbs = (category?: Category): Breadcrumb[] => {
  const breadcrumbs = [
    {title: 'Forsíða', href: paths.home},
    {title: 'Vefverslun', href: paths.categories},
    {
      title: capitalize(category?.parent?.name),
      href: generatePath(paths.categories, category?.parent?.slug),
      shallow: true,
    },
    {
      title: capitalize(category?.name),
      href: generatePath(paths.categories, category?.slug),
      shallow: true,
    },
  ]

  return breadcrumbs
}
